import script from "./ProductoTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductoTable.vue?vue&type=script&setup=true&lang=ts"

import "./ProductoTable.vue?vue&type=style&index=0&id=48663e7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48663e7e"]])

export default __exports__